import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { CreateInvoiceRequest, InvoiceResponse, InvoiceStatus } from '../types/domain';

export interface InvoiceFilters { status?: InvoiceStatus; clientId?: string; from?: string; to?: string; }

export function invoiceEndpoints(http: HttpClient) {
  return {
    list: (filters: InvoiceFilters = {}) => http.get<ApiEnvelope<InvoiceResponse[]>>('/v1/invoices', { query: { status: filters.status, clientId: filters.clientId, from: filters.from, to: filters.to } }).then(unwrap),
    get: (id: string) => http.get<ApiEnvelope<InvoiceResponse>>(`/v1/invoices/${id}`).then(unwrap),
    createManual: (body: CreateInvoiceRequest) => http.post<ApiEnvelope<InvoiceResponse>>('/v1/invoices/manual', body).then(unwrap),
    updateStatus: (id: string, status: string) => http.put<ApiEnvelope<InvoiceResponse>>(`/v1/invoices/${id}/status`, { status }).then(unwrap),
  };
}
export type InvoiceEndpoints = ReturnType<typeof invoiceEndpoints>;
